"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANAGE_APPOINTMENT = void 0;
exports.MANAGE_APPOINTMENT = 'manage-appt';
//# sourceMappingURL=constant.js.map